import React from 'react';
import Formulary from './Formulary';
import Information from './Information';
import { Link } from 'react-router-dom';
import Picture from '../../assets/img/vodafone_background.jpg';

function Home({ isLogin, onLoginSuccess, data, setData }) {
  const safeUser = String(data?.username || '');
  const safeUrl = typeof data?.url === 'string' ? data.url : '';

  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${Picture})`,
          backgroundSize: 'cover',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {!isLogin ? (
          <Formulary onLoginSuccess={onLoginSuccess} setData={setData} />
        ) : (
          <Information user={safeUser} url={safeUrl} />
        )}
      </div>

      <div style={{ padding: '70px', margin: "0" }}>
        {!isLogin ? (
          <>
            <p style={{ fontSize: '33px', margin: "0", marginBottom: "20px" }}>
              Bienvenid@ a Vodafone Solución Profesional
            </p>
            <p style={{fontSize: '16px', color: 'red', margin: "0", marginBottom: "5px" }}>
              Disponible para equipos informáticos, Smartphones y Tablets.
            </p>
            <p style={{fontSize: '14px', margin: "0" }}>
              Accede a nuestro servicio. Si no estás registrado{' '}
              <Link to="/register">pulsa aquí</Link>
            </p>
          </>
        ) : (
          <>
            <p style={{ fontSize: '33px' }}>
              Bienvenid@ a Vodafone Solución Profesional
            </p>
            <p style={{ color: 'red' }}>
              Disponible para equipos informáticos, Smartphones y Tablets
            </p>
            <p>
              Accede a nuestro servicio. Si no estás registrado{' '}
              <Link to="/register">pulsa aquí</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default Home;
